var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRhpIconLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "756px",
    height: "755px",
    viewBox: "0 0 756.0 755.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1024,0 L1024,1024 L0,1024 L0,0 L1024,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.5,0 C151.347763,0 195,43.6522369 195,97.5 C195,151.347763 151.347763,195 97.5,195 C43.6522369,195 0,151.347763 0,97.5 C0,43.6522369 43.6522369,0 97.5,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.14184,67.8177559 C336.257992,27.0536025 372.142398,-2.93867616 412.881753,0.229522293 L415.83694,0.546342138 C606.86863,19.5555328 755.894458,180.816834 756,376.822712 C756,585.712596 586.81558,755 378.052771,755 C316.416027,755 258.156638,740.215074 206.757504,714.024633 L126.756387,748.980423 L126.650845,748.980423 C123.062404,750.564522 118.946252,751.514982 114.724557,751.514982 C98.7876588,751.514982 85.8059472,738.630975 85.8059472,722.578769 C85.8059472,721.417096 85.9114896,720.255424 86.017032,719.199358 L86.1225743,718.776931 C86.1225743,718.460111 86.2281167,718.143291 86.2281167,717.826472 L98.3654893,631.229047 C37.2564568,564.06324 0,474.82565 0,376.822712 C0,348.520139 3.06072874,320.851206 8.97110149,294.343945 L9.39327098,292.759846 C19.4197962,251.045233 58.2593885,226.650105 98.9987435,235.098634 C139.738099,243.547163 165.912606,283.57207 157.469217,324.336224 C153.353064,341.338889 151.347759,359.186407 151.347759,377.456351 C151.347759,503.23383 253.407232,605.24982 379.002653,605.24982 C504.598073,605.24982 606.552003,503.23383 606.552003,377.456351 C606.552003,258.965729 516.207734,161.702037 400.744381,150.718949 L399.583415,150.507735 C358.105263,146.283471 327.920145,109.321156 332.14184,67.8177559 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-134.0 -135.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(134.0 135.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(107.0 38.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 195,0 195,195 0,195 0,0",
    stroke: "none",
    fill: "#B92226"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i2)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,1.77635684e-15 756,1.77635684e-15 756,755 0,755 0,1.77635684e-15",
    stroke: "none",
    fill: "#B92226"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRhpIconLogo);
export default __webpack_public_path__ + "static/media/rhpIconLogo.a8fe437b720a6f19a38ed859e2384bca.svg";
export { ForwardRef as ReactComponent };